import React from 'react';
import { uploadCostFile } from '../../API/costUploadApi';
import CostUploadHistory from '../../shared/CostUploadHistoryTable/CostUploadHistoryTable';
import AlertManager from "../../shared/Alert/Alert";
import { COST_TYPE_OPTIONS, COST_TYPES } from "./CostUploadConstants";
import classes from "./CostUpload.module.css";
import { useUploadHistory } from "../CostUploadHistory/CostUploadHistory.hooks";
import {Button, Box} from "@mui/material";
import classess from "./CostUpload.module.css";
import {downloadTemplateFile} from "../../API/costDownloadTemplateFileApi";

//import { getCostUploadHistory } from '../../API/costUploadHistoryApi';

const CostUpload = () => {
    const { uploadHistory, fetchUploadHistory, loading } = useUploadHistory();
    
    //const[uploadHistory ,fetchUploadHistory] = useState([]);   
    const upload = (e) => {
        e.preventDefault();
        const form = new FormData(e.target);

        const file = form.get("file");
        const costType = form.get("costType");
        const target = e.target;

        if (!costType || costType === COST_TYPES.none) {
            AlertManager.error('Please select the cost type.', { contactSupport: false });
            return;
        }

        if (!file) {
            AlertManager.error('Please select the file that wanted to upload.', { contactSupport: true });
            return;
        }
        if (!file.name.toLocaleLowerCase().endsWith("xlsx") && !file.name.toLocaleLowerCase().endsWith("xls")) {
            AlertManager.error('Please select file with extension .xlsx or .xls', { contactSupport: false });
            return;
        }

        uploadCostFile(file, costType === COST_TYPES.approved)
            .then((res) => {
                if (res.status === 200 || res.status === 201) {
                   fetchUploadHistory();
                    AlertManager.success("The Process has successfully received the file. You will receive an email shortly with the result!", { contactSupport: false });

                    target.reset();
                }
                else {
                    res.json().then(data => {
                        if (res.status === 429) {
                            AlertManager.warning(data.error);
                        } else {
                            AlertManager.error('There were some issues while uploading the file.'

                            );
                        }
                    }).catch(() => {
                        AlertManager.error('There were some issues while processing the server response.');
                    });
                }
            })
            .catch((err) => {
                AlertManager.error('Error');
            });
    };

    return (
        <div className={classes.body}>
            <div className={classes.heading}>Upload Cost Data</div>
            <form 
            className={classes.container} 
            onSubmit={upload}
            data-testid="upload-form"
            >
                     <Box className={classes.box}>
                <input 
                className={classes.fileUploadInputFile} 
                name={"file"} 
                type="file" 
                accept={".xlsx, .xls"} 
                data-testid="file-input"
                />
                </Box>
                <Box className={classes.box}>
                <select 
                className={classes.fileUploadInput} 
                name="costType" 
                id="cost-type"
                data-testid="cost-type"
                >
                    {COST_TYPE_OPTIONS.map(({ value, label }) =>
                        <option key={value} value={value}>{label}</option>
                    )}
                </select>
                </Box>
                <br />
                <button className={classes.uploadBtn} 
                data-testid="upload-btn"
                >upload</button>
                <Button 
                className={classess.uploadBtn}
                onClick={() => downloadTemplateFile()}
                data-testid="template-btn"
                >
                    Template
                </Button>
            </form>

            <div className={classes.hLine}></div>

            <div className={classes.fileuploadHistory}>
                <CostUploadHistory uploadHistory={uploadHistory} loading={loading}/>
            </div>

        </div>
    );
};

export default CostUpload;
